/** Returns the column with its output type fields replaced by its input type fields. */
export const inputColumnView = (col) => {
  if (col == null || !("_inputType" in col)) return col;
  return {
    ...col,
    _type: col._inputType,
    _subType: col._inputSubType,
    _options: col._inputOptions,
    _dataType: col._inputDataType,
    _defaultDecimals: col._inputDefaultDecimals,
  };
};
